import React from "react"
import RPMAdminPatient from "../RPMAdminPatient/RPMAdminPatient"

const RPMViewCare = () => <RPMAdminPatient isFromAddPatient={false} />

export default RPMViewCare
